import * as React from 'react'

import {
  Consumer,
  LanguageContext,
} from './Language'

export interface InjectedLangContextProps {
  language: LanguageContext
}

type WrappedComponent<Props> = React.ComponentType<Props & InjectedLangContextProps>
type WithLanguage = <Props = {}>(Component: WrappedComponent<Props>) => React.ComponentType<Props>

const withLanguageContext: WithLanguage = (Component) => {
  return (props) => {
    const renderProp = (languageContext: LanguageContext) => (
      <Component
        {...props}
        language={languageContext}
      />
    )

    return (
      <Consumer>
        {renderProp}
      </Consumer>
    )
  }
}

export default withLanguageContext



// WEBPACK FOOTER //
// ./src/contexts/Language/withLanguage.tsx